import { Helmet } from "react-helmet-async";

const SITE_URL = "https://thepuropack.com";

export default function Seo({
    title,
    description,
    path = "/",
    canonicalOverride,
    image,
    schema,
    type = "website",
    noindex = false,
}) {
    const canonical = canonicalOverride || `${SITE_URL}${path}`;
    const fullTitle = title
        ? (title.includes("The Puro Pack") ? title : `${title} — The Puro Pack`)
        : "The Puro Pack | Sustainable Food Packaging Manufacturer in Bangalore";
    const desc = description || "The Puro Pack is a Bangalore-based manufacturer of premium paper salad bowls, soup bowls, kraft food containers, PET flat lids and custom printed sustainable food packaging for restaurants, QSR chains, cloud kitchens and food brands across India.";
    const og = image ? (image.startsWith("http") ? image : `${SITE_URL}${image}`) : `${SITE_URL}/og-image.jpg`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            {noindex && <meta name="robots" content="noindex,nofollow" />}
            <link rel="canonical" href={canonical} />
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={canonical} />
            <meta property="og:image" content={og} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={og} />
            {schema && (
                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            )}
        </Helmet>
    );
}
